import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import styles from './MileageSaarathi.module.css';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const VehicleTable = forwardRef(({ apiType, filterdata, setFleetInsightLoading }, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehicleData, setVehicleData] = useState([]);

  useImperativeHandle(ref, () => ({
    downloadData: () => {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const excelFileName = `${apiType == "best" ? "Best" : "Focus"} Level Summary`;

      const flatData = vehicleData.map((item, index) => ({
        'Sr. no': index + 1,
        'Vin': item?.VIN,
        'Energy Efficiency': Number(item?.EnergyEfficiency)?.toFixed(2) + ' KWh/Km' || null,
      }));

      const ws = XLSX.utils.json_to_sheet(flatData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, excelFileName + fileExtension);

    }
    // }
  }));

  useEffect(() => {
    setFleetInsightLoading(true)
    let apiEnd = '';
    if (apiType === 'best') {
      apiEnd = 'mileage_sarathi_ace/fleet_summary_Best_vehicles';
    } else if (apiType === 'focus') {
      apiEnd = 'mileage_sarathi_ace/fleet_summary_focus_vehicles';
    }

    if (apiEnd) {
      fetchData(
        {
          url: API_URL_MAIN + apiEnd,
          body: { filterdata }
        },

        (data) => {
         const vehicles = (data || []).map((bucket) => ({
  VIN: bucket.key.vehicleId,
  EnergyEfficiency: bucket.Energy_Efficiency?.value?.toFixed(2) ?? '-',
}));

         

          setVehicleData(vehicles);
          setFleetInsightLoading(false)
        }
      );
    }
  }, [apiType, fetchData, filterdata]);

  if (isLoading) return <div>Loading vehicles...</div>;
  if (error) return <div>Error loading vehicle data.</div>;

  return (
    <div className={`table-responsive ${styles.best_vehicle}`} style={{ overflowY: "scroll", height: "300px", }}>
      <table className={`table table-bordered table-hover m-0 ${styles.best_vehicle_table}`}>
        <thead >
          <tr className={`${styles.best_vehicle_tablerow}`} style={{ backgroundColor: '#3d8b9b', color: '#fff', position: 'sticky', top: 0 }}>
            <th>Sr. No.</th>
            <th>VIN</th>
            <th>Energy Efficiency (KWh/Km)</th>
          </tr>
        </thead>
        <tbody>
          {vehicleData.length > 0 ? (
            vehicleData.map((vehicle, index) => (
              <tr key={vehicle.VIN} className={`${styles.best_vehicle_tablerowstyle}`}>
                <td>{index + 1}</td>
                <td>{vehicle.VIN}</td>
                <td>{vehicle.EnergyEfficiency}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
})

export default VehicleTable;